import Vue from 'vue';

export default new Vue();

export const eventTypes = {
  CONFIRM: 'confirm',
};
